<template>
  <el-dialog
    title="Copy Link" :model-value="flagVisible" width="50%" :before-close="handleClose"
  >
    <el-input :model-value="link" placeholder="Link" disabled></el-input>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" @click="handleClose">CANCEL</el-button>
        <el-button size="small" class="el-btn-blue" @click="handleCopy">Copy</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import useClipboard from 'vue-clipboard3'
export default {
  props: {
    flagVisible: Boolean,
    link: String
  },
  emits: ['closeModal'],
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleCopy: async function () {
      const { toClipboard } = useClipboard()
      try {
        await toClipboard(this.link)
        this.$message({ type: 'success', message: 'Copied to clipboard' })
        this.handleClose()
      } catch (e) {
        this.$message({ type: 'error', message: e })
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
